export default "__VITE_ASSET__1Afy9goi__"